<template>
  <div>
    <h2>Purchasing Order</h2>
    <!-- <span> -->
    <!-- <b-button variant="primary">Thêm</b-button><br></span> -->
    <div>
      <b-button
        @click="form_data = {}"
        v-b-modal.modal-po-form
        variant="primary"
        >Thêm Mới</b-button
      >
      &nbsp;
      <b-button
        @click="export_excel([['Tổng Extension Price: ', tong_extension_price + ' USD'], ['Tổng Số Lượng: ', tong_so_luong]])"
        variant="primary"
        >Export Excel</b-button
      >
      &nbsp;
      <input id="fileUpload"  type="file" v-on:change="upload_excel_file"  hidden>

      <b-button @click="import_excel" variant="primary">Import Excel</b-button>
      <hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px" />
      <table>
        <tr>
          <th>Từ Ngày</th>
          <th>Đến ngày</th>
          <th></th>
          <th class="px-5">Tổng Extension Price</th>
          <th class="px-5">Tổng Số Lượng</th>
        </tr>
        <tr>
          <td><input id="date-filter-start" /></td>
          <td><input id="date-filter-end" /></td>
          <td></td>
          <td class="px-5 " id="tong_extension_price">{{tong_extension_price}} USD</td>
          <td class="px-5" id="tong_so_luong">{{tong_so_luong}}</td>
        </tr>
      </table>
      <br>
      <b-modal
        id="modal-po-form"
        no-close-on-backdrop
        hide-header-close
        title="Thêm PO"
      >
        <po-form
          @refresh_table_data="refresh_table_data"
          :form_data="form_data"
          :action="action"
        />
        <template #modal-footer>
          <br />
        </template>
      </b-modal>
    </div>
    <table
      class="table table-hover table-bordered cell-border stripe"
      id="poes_table"
    >
      <thead>
        <tr>
          <th>PO. No</th>
          <th>Pn 13</th>
          <th>Pn 10</th>
          <th>Bosch_No</th>
          <th>Zexel_No</th>
          <th>Stamping</th>
          <th>Quốc Gia</th>
          <th>English Name</th>
          <th>Import Name<br />(Tên nhập khẩu)</th>
          <th>App Name <br />(Tên Ứng Dụng)</th>
          <th>Thuế VAT+TNK</th>
          <th>Quantity</th>
          <th>Giá Nhập DAP <br />(USD)</th>
          <th>Extension Price <br />(USD)</th>
          <th>Giá Vốn<br />Khởi Điểm</th>
          <th>Giá Bán Sỉ <br />(VND)</th>
          <th>Giá Bán Lẻ <br />(VND)</th>
          <th>Lead Time</th>
          <th>Customer</th>
          <th>Remarks</th>
          <th></th>
        </tr>
      </thead>
      <tfoot>
        <tr>
          <th>PO. No</th>
          <th>Pn 13</th>
          <th>Pn 10</th>
          <th>Bosch_No</th>
          <th>Zexel_No</th>
          <th>Stamping</th>
          <th>Quốc Gia</th>
          <th>English Name</th>
          <th>Import Name<br />(Tên nhập khẩu)</th>
          <th>App Name <br />(Tên Ứng Dụng)</th>
          <th>Thuế VAT+TNK</th>
          <th>Quantity</th>
          <th>Giá Nhập DAP <br />(USD)</th>
          <th>Extension Price <br />(USD)</th>
          <th>Giá Vốn<br />Khởi Điểm</th>
          <th>Giá Bán Sỉ <br />(VND)</th>
          <th>Giá Bán Lẻ <br />(VND)</th>
          <th>Lead Time</th>
          <th>Customer</th>
          <th>Remarks</th>
          <th></th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
 
<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import $ from "jquery";

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import POForm from "./POForm.vue";
import axios from "axios";
import tool_mixin from "./tool_mixins.js";
import moment from "moment";
import "daterangepicker/daterangepicker";
import "daterangepicker/daterangepicker.css";
import XLSX from 'xlsx';

export default {
  mixins: [tool_mixin],
  data: function () {
    return {
      table: null,
      export_file_name: "PO_" + moment().format("DD_MM_YYYY"),
      form_data: {},
      action: "Tạo",
      tong_extension_price: 0,
      tong_so_luong: 0,
      columns: [
        { data: "po_no", width: 150},
        { data: "pn_13" },
        { data: "pn_10" },
        { data: "bosch_no" },
        { data: "z_exel_no" },
        { data: "stamping" },
        { data: "country" },
        { data: "english_des" },
        { data: "import_des" },
        { data: "app_des" },
        { data: "tax" },
        { name: "quantity", data: "quantity" },
        {
          name: "dap_price",
          data: "dap_price",
          render: $.fn.dataTable.render.number(",", ".", 2),
        },
        {
          name: "extension_price",
          data: "extension_price",
          render: $.fn.dataTable.render.number(",", ".", 2),
        },
        { 
          name: "gia_von",
          data: "gia_von", render: $.fn.dataTable.render.number(",", ".", 2) },
        { data: "gia_si", render: $.fn.dataTable.render.number(",", ".", 2) },
        { data: "gia_le", render: $.fn.dataTable.render.number(",", ".", 2) },
        { data: "lead_time" },
        { data: "customer" },
        { data: "remarks" },
        {
          data: null,
          width: 100,
          defaultContent:
            '<button type="button" action="edit" v-b-modal.modal-po-form class="btn btn-warning flat">Sửa</button>\
              <button type="button" action="delete" class="btn btn-danger flat">Xóa</button>',
        },
      ],
      table_data_url:
        process.env.VUE_APP_API_ENDPOINT + "/api/v1/purchasing-orders",
      date_filter_start: null,
      date_filter_end: null,
    };
  },
  components: {
    "po-form": POForm,
  },
  mounted() {
    let url = this.table_data_url;
    this.generate_search_boxes();
    var component = this;
    this.table = $("#poes_table").DataTable({
      pageLength: 50,
      ajax: {
        url: url,
        dataSrc: "",
      },
      columnDefs: [
        {
          defaultContent: "-",
          targets: "_all",
        },
      ],
      columns: this.columns,
      scrollX: true,
      initComplete: function () {
          // Apply the search
          this.api().columns().every( function () {
              var that = this;
              $('input', this.footer()).on('keyup change clear', function () {
                if (that.search() !== this.value) {
                  that.search(this.value).draw();
                }
              });
          });
        let permissions = component.get_permissions()
        if (!permissions.includes("can_view_modify_po_table_buttons"))
          component.table.column(-1).visible(false);
        if (!permissions.includes("can_view_dap_price"))
          component.table.column("dap_price:name").visible(false);
        if (!permissions.includes("can_view_gia_von"))
          component.table.column("gia_von:name").visible(false);  
      },
      drawCallback: function () {
        var api = this.api();
        component.tong_extension_price = api.column("extension_price:name", {page:'all', search: 'applied'} ).data().sum().toLocaleString()
        component.tong_so_luong = api.column("quantity:name", {page:'all', search: 'applied'} ).data().sum().toLocaleString()
      },
      language: {
        lengthMenu: "Hiển thị _MENU_ dòng",
      },
    });

    $("#poes_table tfoot th").each(function () {
      var title = $(this).text();
      $(this).html('<input type="text" placeholder="Tìm ' + title + '" />');
    });

    $("#poes_table tbody").on("click", "button", function () {
      var data = component.table.row($(this).parents("tr")).data();
      if ($(this).attr("action") == "delete") {
        component.delete_po(data.id);
        return;
      }

      component.$bvModal.show("modal-po-form");
      component.form_data = data;
      if ("id" in data) {
        component.action = "Sửa";
      } else {
        component.action = "Tạo";
      }
    });
  },
  methods: {
    import_excel(){
      document.getElementById("fileUpload").click()
    },
    upload_excel_file(e){
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
          return;
      let file = files[0]
      let reader = new FileReader();
      let f = ""
      reader.onload = (e) => {
          f = e.target.result;
          // console.log(f)
          this.send_file(f)
      };
      reader.readAsBinaryString(file);

    },
    send_file(file){
      let base_url = process.env.VUE_APP_API_ENDPOINT;
      let url = base_url + "/api/v1/purchasing-orders/import-excel"
      const wb = XLSX.read(file, { type: 'binary' });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      axios.post(url, {data: data})
      this.fileUpload
      this.refresh_table_data()
    },
    delete_po(id) {
      let base_url = process.env.VUE_APP_API_ENDPOINT;
      let url = base_url + "/api/v1/purchasing-orders" + "/" + id;
      axios.delete(url).then(() => {
        this.$root.$bvModal.msgBoxOk(`Đã Xóa`);
        this.refresh_table_data();
      });
    },
  },
};
</script>

<style scoped>
table.dataTable thead th {
  white-space: nowrap;
}

#poes_table button {
  display: inline-block;
  height: 100px;
}

table.dataTable td {
  padding: 3px 10px;
  width: 1px;
  white-space: nowrap;
}
</style>
